module.exports = __webpack_public_path__ + "static/img/5.45f61a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/5.png
// module id = wcS7
// module chunks = 0